import Swal, { SweetAlertOptions } from 'sweetalert2';
import { AxCalendarTrinity, InfoObject, Options } from "../../Components/AxCalendar/AxCalendar";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoad } from '../../Lib/AxSystem/AxLoad';
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import { AxLimeStone } from '../../Limestone/AxLimeStone';
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import { BaseJsonResult } from "../../Models/Base";
import { TimeSlotKey } from "../../Models/Reservation/TimeSlotKey";
import { DateModule } from '../Global/DateModule';
import { LocalizationModule } from '../Global/LocalizationModule';

@ModuleName("ReservationCalendar")
export class ReservationCalendar implements AxInit {
    private $parent: JQuery = $('[data-frontoffice-view="reservation"]');
    private localization = AxLoad.GetModule<LocalizationModule>('LocalizationModule');
    private initData!: initData;
    private request = new RequestHelper();
    private i18nHelper = new I18nHelper();
    private calendar: AxCalendarTrinity = new AxCalendarTrinity();
    private calendarMobile: AxCalendarTrinity = new AxCalendarTrinity();
    private closingDays: string[] = [];
    private reservedSlots: string[] = [];
    private availableSlots: string[] = [];
    private selectedTimeSlots: TimeSlotKey[] = [];
    private axLoading: AxLoading = new AxLoading();
    private limestone: AxLimeStone = new AxLimeStone();
    private currentSlot: BookingTimeSlot = {} as BookingTimeSlot;
    private dateModule: DateModule = AxLoad.GetModule<DateModule>('DateModule');

    AxInit(init: initData) {
        const start: moment.Moment = init.StartDate;
        const end: moment.Moment = init.EndDate as moment.Moment;
        this.closingDays = init?.ClosingDays.map(d => moment(d).format('YYYY-MM-DD')) ?? [];
        this.reservedSlots = init?.ReservedSlots.map(d => moment(d).format('YYYY-MM-DD')) ?? [];
        this.availableSlots = init?.AvailableSlots.map(d => moment(d).format('YYYY-MM-DD')) ?? [];
        this.currentSlot = JSON.parse(init.CurrentSlot || '{}');

        const initDesktop: initData = {
            ...init,
            Months: 1,
        }

        const initMobile: initData = {
            ...init,
            RootElement: 'calendarWrapper--trinity-mobile',
            WeekdayLegendSelector: '',
            MonthHeaderShowText: true,
        }

        this.initData = initDesktop;

        this.calendar.showCalendar(init.Month, init.Year, initDesktop);
        this.calendarMobile.showCalendar(initMobile.Month, initMobile.Year, initMobile);

        this.$parent
            .on('click', '[data-reservation="collapser"]', (e) => {
                const $wrapper = $(e.currentTarget).siblings();
                const $icons = $(e.currentTarget).find('i');
                $wrapper.toggleClass('collapsed');
                $icons[$wrapper.hasClass('collapsed') ? 'addClass' : 'removeClass']('la-angle-down')
                $icons[!$wrapper.hasClass('collapsed') ? 'addClass' : 'removeClass']('la-angle-up')
            })

            .on('click', '#calendarWrapper-header--previous', (e) => {
                const $target = this.$parent.find('#calendarWrapper-header--monthname');
                const currentMonth = moment($target.text(), 'MMMM YYYY', this.initData.Lang);
                if (currentMonth.isSameOrBefore(start, 'month')) return false;
                this.calendar.previous(false, () => {
                    $target.html(currentMonth.clone().subtract(1, 'month').format('MMMM YYYY'));
                    this.loadAvailable();
                });
            })

            .on('click', '#calendarWrapper-header--next', (e) => {
                const $target = this.$parent.find('#calendarWrapper-header--monthname');
                const currentMonth = moment($target.text(), 'MMMM YYYY', this.initData.Lang);
                if (currentMonth.isSameOrAfter(end, 'month')) return false;
                this.calendar.next(false, () => {
                    $target.html(currentMonth.clone().add(1, 'month').format('MMMM YYYY'));
                    this.loadAvailable();
                });
            })

            .on('click', 'button.ax-chip', (e) => this.selectContingents(e.currentTarget))

            .on('click', '[data-reservation="back-anchor"]', (e) => {
                const $button = this.$parent.find(`[data-reservation="${this.initData.IsReschedule ? 'reschedule' : 'reserve'}"]`);
                this.limestone.LockButton($button.get(0) as HTMLElement);
                this.limestone.LockButton($('[data-reservation="back-anchor"]').get(0) as HTMLElement, 'ax-btn-loading-secondary');
                this.limestone.LockButton($('[data-reservation="back-anchor"]').get(1) as HTMLElement, 'ax-btn-loading-secondary');
            })

            .on('click', `[data-reservation="${this.initData.IsReschedule ? 'reschedule' : 'reserve'}"]`, () => this.saveData());

        this.loadAvailable();
    }

    loadAvailable() {
        const start = this.initData.StartDate as moment.Moment;
        const end = this.initData.EndDate as moment.Moment;
        const totalDays = end.diff(start, 'days') + 1;
        const today = this.dateModule.getCompanyDate();
        Array.from({ length: totalDays }).forEach((_, index) => {
            const day = start.clone().add(index, 'days');
            const dateStr = day.format('YYYY-MM-DD');
            const currentSlotDate = this.initData.IsReschedule && moment(this.currentSlot.StartTime)?.startOf('date')?.format('YYYY-MM-DD');
            const isReschedule = currentSlotDate && currentSlotDate === dateStr;
            if ((this.reservedSlots.includes(dateStr) && !this.availableSlots.includes(dateStr) && !isReschedule) || dateStr == today) {
                const infoObject: InfoObject = {
                    Date: dateStr,
                    ParentScope: this,
                }
                this.calendarMobile.addCellClass(dateStr, 'allotment__notificiation--info');
                this.calendarMobile.addInfo(infoObject);
                this.calendarMobile.visuallyDeactivateDay(dateStr);
                this.calendar.addCellClass(dateStr, 'allotment__notificiation--info');
                this.calendar.addInfo(infoObject);
                return this.calendar.visuallyDeactivateDay(dateStr);
            }
            if (this.closingDays.includes(dateStr)) {
                this.calendarMobile.visuallyDeactivateDay(dateStr);
                return this.calendar.visuallyDeactivateDay(dateStr);
            }
            const infoObject: InfoObject = {
                Date: dateStr,
                ParentScope: this,
                ActiveClass: 'axc__row_inner--active',
                OnClick: this.activateDay,
            }
            const infoObjectMobile = {
                ...infoObject,
                OnClick: this.activateDayMobile,
            }
            this.calendar.addInfo(infoObject);
            this.calendarMobile.addInfo(infoObjectMobile);
        });
    }

    activateDayMobile(el: Element, parentScope: ReservationCalendar) {
        parentScope.axLoading.ShowLoadingIndicatorFixed($(el).get(0) as HTMLElement);
        return parentScope.activateDay(el, parentScope, true);
    }

    activateDay(el: Element, parentScope: ReservationCalendar, isMobile: boolean = false) {
        const dateString: string = el.getAttribute('data-date') as string;
        const columnContingents: HTMLElement = parentScope.$parent.find('[data-reservation="contingents"]').get(0) as HTMLElement;
        const $currentDateInfoGroup = parentScope.$parent.find('[data-reservation="date-info-group"]');
        const $currentDateTitle = parentScope.$parent.find('[data-reservation="current-date-title"]');
        const $reserveButtonContainer = parentScope.$parent.find('[data-reservation="reserve"]').parent();
        const $timeSlotsContainer = parentScope.$parent.find(`[data-reservation="contingents"][data-media="${isMobile ? 'mobile' : 'desktop'}"]`);
        const $timeSlots = parentScope.$parent.find('[data-reservation="time-slots"]');
        const slot = $timeSlots.attr('data-reservation-slot') as string;
        const $dockDrawer = $('[data-reservation="dock-drawer"]');
        const $button = $timeSlots.siblings().find('[data-reservation="reserve"]');

        $currentDateInfoGroup.addClass('d-none');
        $reserveButtonContainer?.addClass('d-none');
        $timeSlots?.html('');
        parentScope.selectedTimeSlots = [];
        $button.prop('disabled', true);

        parentScope.axLoading.ShowLoadingIndicator(columnContingents, true);

        const url = '/Reservation/GetTimeSlots';
        const data = {
            ticketTriple: parentScope.initData?.Ticket,
            date: dateString,
            contingentBookingType: parentScope?.currentSlot?.ContingentBookingType,
            slot,
        }
        const getTimeSlots = AxessViewer.loadPartialView(url, data, (res: BaseJsonResult) => {
            if (res.success) {
                const date: string = moment(dateString, 'YYYY-MM-DD')?.format('dddd, D MMMM, YYYY');
                $timeSlotsContainer.removeClass('d-none');
                if (date) {
                    $currentDateTitle?.html(date).parent();
                    $currentDateInfoGroup.removeClass('d-none');
                    $reserveButtonContainer?.removeClass('d-none');
                }
                if (slot) {
                    $button.attr('data-reservation-slot', slot);
                    $button.attr('data-reservation', 'reschedule');
                    $button.text(parentScope.i18nHelper.GetTranslation(Translations.Reschedule));
                }
                if (isMobile) {
                    parentScope.axLoading.HideLoadingIndicator(el as HTMLElement);
                    $timeSlotsContainer.siblings().addClass('d-none');
                    $dockDrawer.parent().removeClass('ax-dock-drawer--docked');
                    $dockDrawer.off('click').on('click', () => {
                        $(window).scrollTop(0);
                        $dockDrawer.parent().toggleClass('ax-dock-drawer--docked');
                        if ($dockDrawer.parent().hasClass('ax-dock-drawer--docked')) {
                            $timeSlotsContainer.siblings('[data-reservation="calendar"]').removeClass('d-none');
                            $timeSlotsContainer.siblings('[data-reservation="data"][data-media="mobile"]').removeClass('d-none');
                        } else {
                            $timeSlotsContainer.siblings().addClass('d-none');
                        }
                    });
                }
                $(window).scrollTop(0);
                $timeSlots?.html(res.data);
            }
        }, {
            silent: true,
        });

        getTimeSlots.always(() => parentScope.axLoading.HideLoadingIndicator(columnContingents));
    }

    selectContingents(el: HTMLElement): void {
        const $el: JQuery<Element> = $(el);
        const color: string = 'green';
        const filled = `ax-fill-${color}-500`;
        const outlined = `ax-outline-${color}-500`;
        const $button = this.$parent.find(`[data-reservation="${this.initData.IsReschedule ? 'reschedule' : 'reserve'}"]`);
        const max = Number($el.closest('[data-reservation-max]').attr('data-reservation-max') as string);
        const $timeSlotsGroups = this.$parent.find('div[data-timeslotgroupkey]');

        const timeSlotGroupKey: number = Number(el.dataset.timeslotgroupkey as string);
        const timeSlotKey1 = el.dataset.timeslotkey1 as string;
        const timeSlotKey2: number = Number(el.dataset.timeslotkey2 as string);

        const timeSlotKey: TimeSlotKey = new TimeSlotKey(timeSlotGroupKey, timeSlotKey1, timeSlotKey2);

        if ($el.hasClass(filled)) {
            this.selectedTimeSlots = this.selectedTimeSlots.filter(x => x.timeSlotKey1 !== timeSlotKey1)
            $el.removeClass(filled).addClass(outlined);
        } else {
            const groupCount: number = this.selectedTimeSlots.filter(x => x.timeSlotGroupKey === timeSlotGroupKey).length;
            if (groupCount < max) {
                this.selectedTimeSlots.push(timeSlotKey);
                $el.removeClass(outlined).addClass(filled);
            }
        }

        let totalSlots = 0;
        let totalMax = 0;
        let totalMin = 0;
        $timeSlotsGroups.each((_, el) => {
            const grouptotal = this.selectedTimeSlots.filter((x) => x.timeSlotGroupKey === Number($(el).attr('data-timeslotgroupkey') as string)).length;
            totalSlots += grouptotal;
            totalMax += Number($(el).attr('data-reservation-max') as string);
            totalMin += Number($(el).attr('data-reservation-min') as string);
        });

        $button.prop('disabled', !(totalSlots <= totalMax && totalSlots >= totalMin));
    }

    saveData(): void {
        const [projNr, posNr, serialNr] = this.request.getEntityTripleFromUrl(window.location.href)!;
        const $button = this.$parent.find(`[data-reservation="${this.initData.IsReschedule ? 'reschedule' : 'reserve'}"]`);

        if (projNr && posNr && serialNr && this.selectedTimeSlots.length >= 1) {
            Swal.fire({
                title: this.i18nHelper.GetTranslation(Translations.AreYouSure),
                showCancelButton: true,
                cancelButtonText: this.i18nHelper.GetTranslation(Translations.Cancel),
                confirmButtonText: this.i18nHelper.GetTranslation(Translations.ConfirmReservation),
            } as SweetAlertOptions).then((res) => {
                if (res.value) {
                    const data = {
                        projNr,
                        posNr,
                        serialNr,
                        timeSlots: this.selectedTimeSlots,
                    }
                    if (this.initData.IsReschedule) {
                        data['slotTriple'] = $button.attr('data-reservation-slot') as string;
                    }

                    this.limestone.LockButton($button.get(0) as HTMLElement);
                    this.limestone.LockButton($('[data-reservation="back-anchor"]').get(0) as HTMLElement, 'ax-btn-loading-secondary');
                    this.limestone.LockButton($('[data-reservation="back-anchor"]').get(1) as HTMLElement, 'ax-btn-loading-secondary');

                    AxessViewer.loadPartialView('/Reservation/SaveReservation', data, (res: BaseJsonResult) => {
                        const title = res.success
                            ? `${this.i18nHelper.GetTranslation(Translations.Success)}!`
                            : `${this.i18nHelper.GetTranslation(Translations.Error)}`
                        const icon = res.success ? 'success' : 'error';
                        Swal
                            .fire({
                                title,
                                icon,
                                text: res.message,
                                confirmButtonText: this.i18nHelper.GetTranslation(Translations.Ok),
                            })
                            .then((result) => {
                                if (result.value && res.success) {
                                    const useWtpOrSerial = this.getQuerystring();
                                    const url = `/${this.localization.getSelectedLanguage()}/Reservation${useWtpOrSerial}`;
                                    window.location.href = this.request.getFullUrl(url);
                                }
                            });
                    }, {
                        silent: true,
                    });
                }
            });
        }
    }

    getQuerystring() {
        const url = new URL(window.location.href);
        const params = url.searchParams;
        const wtp = params.get('wtp') ? `?wtp=${params.get('wtp')}` : '';
        const serial = params.get('serial') ? `?serial=${(params.get('serial') as string).replace(/\//g, '-')}` : '';
        return (wtp.length > 0 && wtp) || serial;
    }
}

interface initData extends Options {
    Year: number;
    Month: number;
    ClosingDays: string[];
    ReservedSlots: string[];
    AvailableSlots: string[];
    Ticket: string;
    IsReschedule: boolean;
    CurrentSlot: string;
}

interface BookingTimeSlot {
    ConfigNo: number;
    ConfigLimitNo: number;
    SlotLfdNr: number;
    StartTime: string | Date;
    EndTime: string | Date;
    Name: string;
    Desc: string;
    ContingentBookingType: ContingentBookingType;
    CurrentBooking: number;
    CurrentReservation: number;
    MaxBookings: number;
    ConfigName: string;
    TicketCountFree: number;
    SerienNo?: number | null;
    TimeSlotKey: TimeSlotKey;
    LanguageID: number;
    Language: string;
}

enum ContingentBookingType {
    FirstDay,
    EveryDay,
    LastDay,
}